import { render, staticRenderFns } from "./updateSolution.vue?vue&type=template&id=0ba5cdea&"
import script from "./updateSolution.vue?vue&type=script&lang=ts&"
export * from "./updateSolution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports